<template>
    <v-container fluid class="incidente-root">
        <div>
            <v-row>
                <v-col cols="12" md="12">
                    <div v-if="!temp & soloLectura">
                        <v-img style="margin:auto;" :src="require('@/assets/logoun.png')" max-width="50%" contain/>

                        <!-- Título con línea -->
                        <h2 class="section-title">Perfil - Hoja de vida</h2>
                        <v-divider class="section-divider"></v-divider>

                        <p class="section-text">
                            Para garantizar un proceso de selección transparente y justo, es fundamental que su perfil esté diligenciado en su totalidad. 
                            Asegúrese de registrar información personal, académica y laboral completa y actualizada, ya que esta será utilizada para validar 
                            su experiencia y competencias. Solo los usuarios con un perfil completo podrán ingresar y aplicar a las vacantes disponibles en la 
                            plataforma. Recuerde que mantener su información actualizada aumenta sus posibilidades de ser tenido en cuenta en los procesos de selección.
                        </p>
                        <v-divider class="section-divider"></v-divider>
                    </div>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-icon large v-on="on" @click="mostrar(userOid)">print</v-icon>
                        </template>
                        <span>Ver HV</span>
                    </v-tooltip>
                    <!-- Otro bloque -->
                    <h2 class="section-title" v-if="!temp & !soloLectura">Información de la Hoja de Vida</h2>

                    <v-divider class="section-divider"></v-divider>
                    <h4 class="section-title2" v-if="temp">Información de la Hoja de Vida</h4>
                    <br>
                    <div class="actions" v-if="!temp & soloLectura">
                        <v-spacer></v-spacer>

                        <!-- Nuevo: Finalizar perfil -->
                        <v-btn color="#1BA397" dark :disabled="!perfilCompleto" @click="finalizarPerfil">
                            Finalizar perfil
                        </v-btn>
                    </div>
                    <br>
                    <!-- Progreso global -->
                    <v-progress-linear :value="progress" height="6" class="mb-4" v-if="!temp & !soloLectura"/>

                    <!-- STEPPER -->
                    <v-stepper v-model="step" v-if="!temp & !soloLectura">
                        <v-stepper-header>
                            <v-stepper-step :complete="isDone.general" step="1" :color="isDone.general ? 'success' : undefined" complete-icon="mdi-check-circle" editable>Información General</v-stepper-step>
                            <v-divider></v-divider>

                            <!-- <v-stepper-step :complete="isDone.academica" :color="isDone.academica ? 'success' : undefined" complete-icon="mdi-check-circle" step="2" editable>Información Académica</v-stepper-step>
                            <v-divider></v-divider>

                            <v-stepper-step :complete="isDone.laboral" :color="isDone.laboral ? 'success' : undefined" complete-icon="mdi-check-circle" step="3" editable>Información Laboral</v-stepper-step>
                            <v-divider></v-divider>

                            <v-stepper-step :complete="isDone.idioma" :color="isDone.idioma ? 'success' : undefined" complete-icon="mdi-check-circle" step="4" editable>Idiomas</v-stepper-step>
                            <v-divider></v-divider>

                            <v-stepper-step :complete="isDone.otros" :color="isDone.otros ? 'success' : undefined" complete-icon="mdi-check-circle" step="5" editable>Otros</v-stepper-step>
                            <v-divider></v-divider>

                            <v-stepper-step :complete="isDone.referencias" :color="isDone.referencias ? 'success' : undefined" complete-icon="mdi-check-circle" step="6" editable>Referencias</v-stepper-step>
                            <v-divider></v-divider> -->

                        </v-stepper-header>

                        <v-stepper-items>
                            <!-- Paso 1: General -->
                            <v-stepper-content step="1">
                                <v-form ref="frmGeneral" v-model="valid.general" lazy-validation>
                                    <h3 class="text-center blue--text">Información Personal</h3>
                                    <v-row>
                                        <v-col cols="12" md="4">
                                            <v-text-field v-model="dato.correo" :rules="[r.email]" label="Correo" required class="rounded"/>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-text-field v-model="dato.nombres" :rules="[r.req]" label="Nombres" required class="rounded"/>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-text-field v-model="dato.apellidos" :rules="[r.req]" label="Apellidos" required class="rounded"/>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                            <v-select v-model="dato.oid_tipo_documento" :rules="[r.combo]" :items="Catalogo.TipoDocumento" item-text="nombre" item-value="oid" label="Tipo de Documento" class="rounded"/>
                                        </v-col>
                                        <v-col cols="12" md="2">
                                            <v-text-field v-model="dato.documento" :rules="[r.req]" label="Número de Identificación" required class="rounded"/>
                                        </v-col>
                                        <v-col cols="12" md="2">
                                            <v-select v-model="dato.oid_genero" :rules="[r.combo]" :items="Catalogo.Genero" item-text="nombre" item-value="oid" label="Género" class="rounded"/>
                                        </v-col>
                                        <v-col cols="12" md="2">
                                            <v-text-field v-model="dato.fecha_nacimiento" :min="minDate" :max="maxDate" :rules="[r.date]" label="Fecha Nacimiento" type="date" required/>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                            <v-select v-model="dato.oid_pais_nacimiento" :items="LPais" item-text="nombre" item-value="oid"
                                                    :rules="[r.combo]" label="País Nacimiento" required class="rounded"/>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                            <v-select v-model="dato.oid_nacionalidad_origen" :rules="[r.combo]" :items="Catalogo.Nacionalidad" item-text="nombre" item-value="oid" label="Nacionalidad Origen" class="rounded"/>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                            <v-select v-model="dato.oid_nacionalidad_actual" :rules="[r.combo]" :items="Catalogo.Nacionalidad" item-text="nombre" item-value="oid" label="Nacionalidad Actual" class="rounded"/>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                            <v-select v-model="dato.oid_estado_civil" :rules="[r.combo]" :items="Catalogo.EstadoCivil" item-text="nombre" item-value="oid" label="Estado Civil" class="rounded"/>
                                        </v-col>
                                    </v-row>

                                    <h3 class="text-center blue--text">Ubicación Actual</h3>
                                    <v-row>
                                        <v-col cols="12" md="4">
                                            <v-text-field v-model="dato.direccion" :rules="[r.req]" label="Dirección" required class="rounded"/>
                                        </v-col>
                                        <v-col cols="12" md="2">
                                            <v-select v-model="dato.oid_pais" :rules="[r.combo]" :items="LPais" item-text="nombre" item-value="oid"
                                                    label="País" required class="rounded"/>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                            <v-select v-model="dato.oid_depto" :rules="[r.combo]" :items="deptoFiltrado" item-text="nombre" item-value="oid"
                                                    label="Departamento" required class="rounded"/>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                            <v-select v-model="dato.oid_ciudad" :rules="[r.combo]" :items="ciudadFiltrado" item-text="nombre" item-value="oid"
                                                    label="Ciudad" required class="rounded"/>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                            <v-text-field v-model="dato.telefono" :rules="[r.phone]" label="Número Celular" required class="rounded"/>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                            <v-select v-model="dato.oid_idioma_nativo" :rules="[r.combo]" :items="Catalogo.Idioma" item-text="nombre" item-value="oid" label="Idioma Nativo" class="rounded"/>
                                        </v-col>
                                    </v-row>
                                    <v-divider class="section-divider"></v-divider><br><br>

                                    <h3 class="text-center blue--text">Enfoques de Genero</h3>
                                    <v-row>
                                        <v-col cols="12" md="4">
                                            <v-select :items="Ops" item-text="name" item-value="oid"
                                                    label="Pertenece a un grupo Etnico" required class="rounded"/>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-select :items="Ops" item-text="name" item-value="oid"
                                                    label="Pertenece a un grupo LGTBIQ+" required class="rounded"/>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-select :items="Ops" item-text="name" item-value="oid"
                                                    label="Pertenece a un grupo con Discapacidad" required class="rounded"/>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-select :items="Ops" item-text="name" item-value="oid"
                                                    label="Pertenece a un grupo Indigena" required class="rounded"/>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-select :items="Ops" item-text="name" item-value="oid"
                                                    label="Pertenece a un grupo Afrodescendiente" required class="rounded"/>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-select :items="Ops" item-text="name" item-value="oid"
                                                    label="Pertenece a un grupo de personas desplazadas" required class="rounded"/>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-select :items="Ops" item-text="name" item-value="oid"
                                                    label="Pertenece a un grupo de Migrantes y/o Refugiados" required class="rounded"/>
                                        </v-col>
                                    </v-row>
                                </v-form>

                                <div class="actions">
                                    <v-spacer></v-spacer>
                                    <!-- <v-btn class="mr-5" outlined color="#0084D1" @click="prevStep" :disabled="step===1">Atrás</v-btn> -->
                                    <v-btn class="mr-5" v-if="!soloLectura" color="#0084D1" dark @click="guardarInfo('frmGeneral','general')" :loading="loading"> Guardar y continuar </v-btn>
                                </div>
                            </v-stepper-content>

                            <!-- Paso 2: Académica 
                            <v-stepper-content step="2">
                                <v-form ref="frmAcademica" v-model="valid.academica">
                                    <info-academica :persona-id="dato.oid" :solo-lectura="this.soloLectura" @estado="isDone.academica = $event"/>
                                </v-form>
                            </v-stepper-content>-->
                            
                            <!-- Paso 3: Laboral 
                            <v-stepper-content step="3">
                                <v-form ref="frmLaboral" v-model="valid.laboral">
                                    <info-laboral :persona-id="dato.oid" :solo-lectura="this.soloLectura" @estado="isDone.laboral = $event"/>
                                </v-form>
                            </v-stepper-content>-->

                            <!-- Paso 4: Idioma
                            <v-stepper-content step="4">
                                <v-form ref="frmIdioma" v-model="valid.idioma">
                                    <info-idioma :persona-id="dato.oid" :solo-lectura="this.soloLectura" @estado="isDone.idioma = $event"/>
                                </v-form>
                            </v-stepper-content> -->
                            
                            <!-- Paso 5: Otros 
                            <v-stepper-content step="5">
                                <v-form ref="frmOtros" v-model="valid.otros">
                                    <info-otros  :persona-id="dato.oid" :solo-lectura="this.soloLectura" @estado="isDone.otros = $event"/>
                                </v-form>
                            </v-stepper-content>-->
                            
                            <!-- Paso 6: Referencias 
                            <v-stepper-content step="6">
                                <v-form ref="frmReferencias" v-model="valid.referencias">
                                    <info-referencia :persona-id="dato.oid" :solo-lectura="this.soloLectura" @estado="isDone.referencias = $event"/>
                                </v-form>
                            </v-stepper-content>-->
                            
                        </v-stepper-items>
                    </v-stepper>

                    <!-- DETALLE PARA VER EN VACANTES -->
                    <div v-if="temp">
                        <v-card>
                            <v-card-title class="headline">Detalle HV</v-card-title>
                            <v-card-text>
                                <div ref="hvPrint" class="print-page">
                                    <v-container grid-list-md>
                                        <!-- General -->
                                        <v-row>
                                            <v-col cols="12">
                                                <h3 class="text-center blue--text">Información General</h3>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <strong>Correo:</strong><br>{{ dato.correo }}
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <strong>Nombres:</strong><br>{{ dato.nombres }}
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <strong>Apellidos:</strong><br>{{ dato.apellidos }}
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <strong>Tipo de Documento:</strong><br>{{ catMap.TipoDocumento[dato.oid_tipo_documento] || '—' }}
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <strong>Documento:</strong><br>{{ (dato.documento) }}
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <strong>Genero:</strong><br>{{ catMap.Genero[dato.oid_genero] || '—' }}
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <strong>Fecha de Nacimiento:</strong><br>{{ (dato.fecha_nacimiento) }}
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <strong>Pais de Nacimiento:</strong><br>{{ getPaisN(dato.oid_pais_nacimiento) }}
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <strong>Nacionalidad de Origen:</strong><br>{{ catMap.Nacionalidad[dato.oid_nacionalidad_origen] || '—' }}
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <strong>Nacionalidad Actual:</strong><br>{{ catMap.Nacionalidad[dato.oid_nacionalidad_actual] || '—' }}
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <strong>Estado Civil:</strong><br>{{ catMap.EstadoCivil[dato.oid_estado_civil] || '—' }}
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <strong>Dirección:</strong><br>{{ dato.direccion }}
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <strong>Pais:</strong><br>{{ getPaisN(dato.oid_pais) }}
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <strong>Departamento:</strong><br>{{ getDeptoN(dato.oid_depto) }}
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <strong>Ciudad:</strong><br>{{ getCiudadN(dato.oid_ciudad) }}
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <strong>Telefono:</strong><br>{{ dato.telefono }}
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <strong>Idioma Nativo:</strong><br>{{ catMap.Idioma[dato.oid_idioma_nativo] || '—' }}
                                            </v-col>
                                        </v-row>
                                        <!-- Academica (cards) -->
                                        <v-row class="mt-6">
                                            <v-col cols="12">
                                                <h3 class="text-center blue--text">Información Académica</h3>
                                            </v-col>

                                            <v-col cols="12" v-if="!resumen.academica?.length">
                                                <em>— Sin registros —</em>
                                            </v-col>

                                            <v-col cols="12" md="4" v-for="a in resumen.academica" :key="a.oid">
                                                <v-sheet class="pa-3 rounded-lg" elevation="1">
                                                <div><strong>{{ a.titulo }}</strong></div>
                                                <div class="grey--text text--darken-1">{{ a.institucion }}</div>
                                                <div class="grey--text text--darken-1">{{ getNameById(a.oid_nivel) }}</div>
                                                <div>
                                                    <small>{{ a.fecha_inicio || '—' }} – {{ a.fecha_fin || 'Actual' }}</small>
                                                </div>
                                                </v-sheet>
                                            </v-col>
                                        </v-row>
                                        <!-- Laboral (cards) -->
                                        <v-row class="mt-6">
                                            <v-col cols="12">
                                                <h3 class="text-center blue--text">Información Laboral</h3>
                                            </v-col>

                                            <v-col cols="12" v-if="!resumen.laboral?.length">
                                                <em>— Sin registros —</em>
                                            </v-col>

                                            <v-col cols="12" md="6" v-for="a in resumen.laboral" :key="a.oid">
                                                <v-sheet class="pa-3 rounded-lg" elevation="1">
                                                    <div><strong>{{ a.cargo }}</strong></div>
                                                    <div class="grey--text text--darken-1">{{ a.nombre }}</div>
                                                    <div class="grey--text text--darken-1">{{ getNameById(a.oid_nivel) }}</div>
                                                    <div class="grey--text text--darken-1"><strong>Motivo de Retiro: </strong>{{ a.motivo }}</div>
                                                    <div class="grey--text text--darken-1"><strong>Salario: </strong>{{ a.salario }}</div>
                                                    <div>
                                                        <small>{{ a.fecha_inicio || '—' }} – {{ a.fecha_fin || 'Actual' }}</small>
                                                    </div>
                                                    <div class="grey--text text--darken-1"><strong>Supervisor: </strong>{{ a.n_supervisor }}</div>
                                                    <div class="grey--text text--darken-1"><strong>Telefono: </strong>{{ a.t_supervisor }}</div>
                                                    <div class="grey--text text--darken-1"><strong>Correo: </strong>{{ a.c_supervisor }}</div>
                                                    <div class="grey--text text--darken-1"><strong>Responsabilidades: </strong><br>{{ a.responsabilidades }}</div>
                                                </v-sheet>
                                            </v-col>
                                        </v-row>
                                        <!-- Idiomas (cards) -->
                                        <v-row class="mt-6">
                                            <v-col cols="12">
                                                <h3 class="text-center blue--text">Idiomas</h3>
                                            </v-col>

                                            <v-col cols="12" v-if="!resumen.idiomas.length">
                                                <em>— Sin idiomas registrados —</em>
                                            </v-col>

                                            <v-col cols="12" md="2" v-for="i in resumen.idiomas" :key="i.oid">
                                                <v-sheet class="pa-3 rounded-lg" elevation="1">
                                                <div><strong>Idioma:</strong> {{ catMap.Idioma[i.oid_idioma] || '—' }}</div>
                                                <div><strong>Nivel:</strong>  {{ nivelLabel(i.oid_nivel) }}</div>
                                                </v-sheet>
                                            </v-col>
                                        </v-row>
                                        <!-- Otros (cards) -->
                                        <v-row class="mt-6">
                                            <v-col cols="12">
                                                <h3 class="text-center blue--text">Otros</h3>
                                            </v-col>

                                            <v-col cols="12" v-if="!resumen.otros?.length">
                                                <em>— Sin registros —</em>
                                            </v-col>

                                            <v-col cols="12" md="12" v-for="a in resumen.otros" :key="a.oid">
                                                <v-sheet class="pa-3 rounded-lg" elevation="1">
                                                <div class="grey--text text--darken-1">¿Alguna vez cometió, fue investigado, procesado, tuvo un fallo en su contra, o fue condenado por un delito de explotación y/o abuso sexual?: <strong>{{ getOpsN(a.pr1) }}</strong></div>
                                                <div class="grey--text text--darken-1">¿Alguna vez le han impuesto medidas disciplinarias, incluido el despido o la separación del servicio por mala conducta?: <strong>{{ getOpsN(a.pr2) }}</strong></div>
                                                <div class="grey--text text--darken-1">¿Alguna vez ha sido separado del servicio por motivos de desempeño insatisfactorio?: <strong>{{ getOpsN(a.pr3) }}</strong></div>
                                                <div class="grey--text text--darken-1">¿Es usted ahora, o ha sido alguna vez, un empleado público permanente en su gobierno?: <strong>{{ getOpsN(a.pr4) }}</strong></div>
                                                <div class="grey--text text--darken-1">¿Ha cometido, ha sido condenado o procesado por algún delito penal?: <strong>{{ getOpsN(a.pr5) }}</strong></div>
                                                <div class="grey--text text--darken-1">¿Alguna vez ha estado involucrado, por acción u omisión, en la comisión de alguna violación del derecho internacional de los derechos humanos o del derecho internacional humanitario?: <strong>{{ getOpsN(a.pr6) }}</strong></div>
                                                <!-- <div class="grey--text text--darken-1">¿Alguna vez cometió, fue investigado, procesado, tuvo un fallo en su contra, o fue condenado o un delito por participar en explotación y/o abuso sexual?: <strong>{{ getOpsN(a.pr7) }}</strong></div> -->
                                                </v-sheet>
                                            </v-col>
                                        </v-row>
                                        <!-- Referencias (cards) -->
                                        <v-row class="mt-6">
                                            <v-col cols="12">
                                                <h3 class="text-center blue--text">Referencias</h3>
                                            </v-col>

                                            <v-col cols="12" v-if="!resumen.referencias?.length">
                                                <em>— Sin registros —</em>
                                            </v-col>

                                            <v-col cols="12" md="3" v-for="a in resumen.referencias" :key="a.oid">
                                                <v-sheet class="pa-3 rounded-lg" elevation="1">
                                                <div><strong>{{ a.nombre }}</strong></div>
                                                <div class="grey--text text--darken-1"><strong>Cargo: </strong>{{ a.cargo }}</div>
                                                <div class="grey--text text--darken-1"><strong>Profesión: </strong>{{ a.profesion }}</div>
                                                <div class="grey--text text--darken-1"><strong>Telefono: </strong>{{ a.telefono }}</div>
                                                <div class="grey--text text--darken-1"><strong>Correo: </strong>{{ a.correo }}</div>
                                                </v-sheet>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </div>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn color="secondary" text @click="dialogdetail=false">Cerrar</v-btn>
                                <v-btn v-if="perfilCompleto" style="color: white;background-color: #F79321;" text @click="imprimir"> Imprimir HV </v-btn>
                            </v-card-actions>
                        </v-card>
                    </div>
                </v-col>
            </v-row>

            <!-- Diálogo para ver detalle-->
            <v-dialog v-model="dialogdetail" max-width="90%">
                <v-card>
                    <v-card-title class="headline">Detalle HV</v-card-title>
                    <v-card-text>
                        <div ref="hvPrint" class="print-page">
                            <v-container grid-list-md>
                                <!-- General -->
                                <v-row>
                                    <v-col cols="12">
                                        <h3 class="text-center blue--text">Información General</h3>
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <strong>Correo:</strong><br>{{ dato.correo }}
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <strong>Nombres:</strong><br>{{ dato.nombres }}
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <strong>Apellidos:</strong><br>{{ dato.apellidos }}
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <strong>Tipo de Documento:</strong><br>{{ catMap.TipoDocumento[dato.oid_tipo_documento] || '—' }}
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <strong>Documento:</strong><br>{{ (dato.documento) }}
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <strong>Genero:</strong><br>{{ catMap.Genero[dato.oid_genero] || '—' }}
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <strong>Fecha de Nacimiento:</strong><br>{{ (dato.fecha_nacimiento) }}
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <strong>Pais de Nacimiento:</strong><br>{{ getPaisN(dato.oid_pais_nacimiento) }}
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <strong>Nacionalidad de Origen:</strong><br>{{ catMap.Nacionalidad[dato.oid_nacionalidad_origen] || '—' }}
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <strong>Nacionalidad Actual:</strong><br>{{ catMap.Nacionalidad[dato.oid_nacionalidad_actual] || '—' }}
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <strong>Estado Civil:</strong><br>{{ catMap.EstadoCivil[dato.oid_estado_civil] || '—' }}
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <strong>Dirección:</strong><br>{{ dato.direccion }}
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <strong>Pais:</strong><br>{{ getPaisN(dato.oid_pais) }}
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <strong>Departamento:</strong><br>{{ getDeptoN(dato.oid_depto) }}
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <strong>Ciudad:</strong><br>{{ getCiudadN(dato.oid_ciudad) }}
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <strong>Telefono:</strong><br>{{ dato.telefono }}
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <strong>Idioma Nativo:</strong><br>{{ catMap.Idioma[dato.oid_idioma_nativo] || '—' }}
                                    </v-col>
                                </v-row>
                            </v-container>
                        </div>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn color="secondary" text @click="dialogdetail=false">Cerrar</v-btn>
                        <v-btn v-if="perfilCompleto" style="color: white;background-color: #F79321;" text @click="imprimir"> Imprimir HV </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <!-- Diálogo de confirmación -->
            <v-dialog v-model="dialogFinalizado" max-width="520" v-if="!temp & soloLectura">
                <v-card>
                    <v-card-title class="headline">¡Perfil completado! <v-icon style="color: green">check</v-icon></v-card-title>
                    <v-card-text>
                        Tu perfil fue guardado exitosamente. Ya puedes postularte a las vacantes.
                    </v-card-text>
                    <v-card-actions>
                        <v-btn text color="#1BA397" @click="dialogFinalizado = false">Aceptar</v-btn>
                        <v-spacer/>
                        <v-btn text color="#29ABE2" @click="irAVacantes">Ir a vacantes</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

        </div>
    </v-container>
</template>

<script>
import axios from 'axios';
/*import InfoAcademica from '@/components/Persona/Adm_academica.vue';
import InfoLaboral from '@/components/Persona/Adm_laboral.vue';
import InfoIdioma from '@/components/Persona/Adm_idioma.vue';
import InfoOtros from '@/components/Persona/Adm_otros.vue';
import InfoReferencia from '@/components/Persona/Adm_referencias.vue';*/
import {
  loadAll, getOptionsByCodigo,
  setDatos, getPaises, getDeptos, getCiudades,
  getPaisN, getDeptoN, getCiudadN, 
  getNameById
} from '@/utils/catalogo';

export default {
    /*components: {
        InfoAcademica,
        InfoLaboral,
        InfoIdioma,
        InfoOtros,
        InfoReferencia,
    },*/
    name: 'perfil',
    props: {
        oidTemp: { type: Number, required: false },
        soloLectura: { type: Boolean, default: false },
        temp: { type: Boolean, default: false },
    },
    data() {
        return {
            dato: {
                oid: 0,
                correo: '',
                nombres: '',
                apellidos: '',
                oid_tipo_documento: null,
                documento: '',
                oid_genero: null,
                fecha_nacimiento: null,
                oid_pais_nacimiento: null,
                oid_nacionalidad_origen: null,
                oid_nacionalidad_actual: null,
                oid_estado_civil: null,
                direccion: '',
                oid_pais: null,
                oid_depto: null,
                oid_ciudad: null,
                telefono: '',
                oid_idioma_nativo: null,
            },
            Catalogo: {
                EstadoCivil: [],
                TipoDocumento: [],
                Nacionalidad: [],
                Genero: [],
                Idioma: [],
            },
            dialogdetail: false,
            Ops: [
                { oid: 1, name: 'Si' },
                { oid: 0, name: 'No' },
            ],
            LPais: [],
            LDepto: [],
            LCiudad: [],
            step: 1,
            loading: false,
            valid: {
                general: false, academica: false, laboral: false,
                idioma: false, otros: false, referencias: false,
            },
            isDone: {
                general: false, academica: false, laboral: false,
                idioma: false, otros: false, referencias: false,
            },
            minDate: '1900-01-01',
            maxDate: '2099-12-31',
            r: {
                req: v => (v !== null && v !== undefined && String(v).trim() !== '') || 'Campo obligatorio',
                email: v => {
                    if (!v) return 'Campo obligatorio';
                    const re = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
                    return re.test(v) || 'Correo inválido';
                },
                phone: v => {
                    if (!v) return 'Campo obligatorio';
                    return (/^\d{7,15}$/).test(String(v)) || 'Teléfono inválido';
                },
                combo: v => (v !== null && v !== undefined) || 'Seleccione una opción',
                date: v => {
                    if (!v) return 'Seleccione una fecha';
                    const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(v);
                    if (!m) return 'Formato inválido (aaaa-mm-dd)';
                    const y = +m[1];
                    if (y < 1900 || y > 2099) return 'Año fuera de rango (1900–2099)';
                    return true;
                },
            },
            dialogFinalizado: false,
            yaNotificadoPerfilCompleto: false,
            resumen: {
                idiomas: [],
                academica: [],
                laboral: [],
                otros: [],
                referencias: [],
            },
            Ops2: [
                { oid: 1, name: 'Basico' },
                { oid: 2, name: 'Intermedio' },
                { oid: 3, name: 'Avanzado' },
                { oid: 4, name: 'Nativo' },
            ],
        }
    },
    computed: {
        progress() {
            const total = Object.keys(this.isDone).length;
            const done = Object.values(this.isDone).filter(Boolean).length;
            return Math.round((done / total) * 100);
        },
        userName() {
        // Aquí obtén el nombre del usuario autenticado desde Vuex o desde el almacenamiento local
            const user = localStorage.getItem('userName'); 
            return user;
        },
        rolOid() {
        // Aquí obtén el nombre del usuario autenticado desde Vuex o desde el almacenamiento local
            const oid_rol = localStorage.getItem('rolu');
            return Number(oid_rol);
        },    
        userOid() {
        // Aquí obtén el nombre del usuario autenticado desde Vuex o desde el almacenamiento local
            const oid_usuario = localStorage.getItem('oidu');
            return Number(oid_usuario);
        },
        perfilCompleto() {
            // ✅ todos los módulos completos
            return Object.values(this.isDone).every(Boolean);
        },
        deptoFiltrado() {
            if (!this.dato.oid_pais) return [];
            return this.LDepto.filter(d => d.oid_pais === this.dato.oid_pais);
        },
        ciudadFiltrado() {
            if (!this.dato.oid_depto) return [];
            return this.LCiudad.filter(d => d.oid_depto === this.dato.oid_depto);
        },
        catMap() {
            const toMap = arr => (arr || []).reduce((m, it) => { m[it.oid] = it.nombre; return m; }, {});
            return {
                TipoDocumento: toMap(this.Catalogo.TipoDocumento),
                Nacionalidad:  toMap(this.Catalogo.Nacionalidad),
                Genero:        toMap(this.Catalogo.Genero),
                EstadoCivil:   toMap(this.Catalogo.EstadoCivil),
                Idioma:        toMap(this.Catalogo.Idioma),
            };
        }
    },
    methods: {
        async cargarCatalogos() {
            await loadAll();

            this.Catalogo.TipoDocumento   = getOptionsByCodigo('TipoDocumento');
            this.Catalogo.Nacionalidad = getOptionsByCodigo('Nacionalidad');
            this.Catalogo.Genero        = getOptionsByCodigo('Genero');
            this.Catalogo.EstadoCivil        = getOptionsByCodigo('EstadoCivil');
            this.Catalogo.Idioma        = getOptionsByCodigo('Idioma');
        },
        prevStep() { if (this.step > 1) this.step--; },

        async cargarPerfil() {
            try {
                // Decide el OID objetivo
                const targetOid = (this.soloLectura && this.oidTemp) ? this.oidTemp : this.userOid;

                if (!targetOid) {
                // Si es vista de solo lectura y no te pasaron oidTemp, solo avisa
                if (this.soloLectura) {
                    this.$emit?.('toast', { color: 'warning', text: 'No hay persona seleccionada.' });
                } else {
                    // Si es edición del propio perfil y no hay sesión, redirige/abre login
                    this.$router.replace({ name: 'Inicio' });
                }
                return;
                }

                const { data } = await axios.get(`api/PersonaInfoGenerals/Mostrar/${targetOid}`);

                // Mezcla en el modelo del form
                this.dato = {
                    ...this.dato,
                    ...data,
                    oid: data.oid,
          oid_pais: Number(data.oid_pais) || null,
          oid_depto: Number(data.oid_depto) || null,
          oid_ciudad: Number(data.oid_ciudad) || null,
                };
                this.evaluarGeneral()      // ← marca como done si ya está completo
            } catch (e) {
                console.error(e);
                this.$emit('toast', { color: 'error', text: 'No fue posible cargar el perfil.' });
            }
        },
        // Guarda sección y avanza
        async guardarInfo(formRef, sectionKey) {
            const frm = this.$refs[formRef]
            if (!frm || !frm.validate() || !this.dato.oid) return
            this.loading = true
            try {
                const payload = {
                    oid: this.dato.oid,
                    // Campos de la sección 1:
                    correo: this.dato.correo,
                    nombres: this.dato.nombres,
                    apellidos: this.dato.apellidos,
                    oid_tipo_documento: this.dato.oid_tipo_documento,
                    documento: this.dato.documento,
                    oid_genero: this.dato.oid_genero,
                    fecha_nacimiento: this.dato.fecha_nacimiento || null,
                    oid_pais_nacimiento: this.dato.oid_pais_nacimiento,
                    oid_nacionalidad_origen: this.dato.oid_nacionalidad_origen,
                    oid_nacionalidad_actual: this.dato.oid_nacionalidad_actual,
                    oid_estado_civil: this.dato.oid_estado_civil,
                    direccion: this.dato.direccion,
                    oid_pais: this.dato.oid_pais,
                    oid_depto: this.dato.oid_depto,
                    oid_ciudad: this.dato.oid_ciudad,
                    telefono: this.dato.telefono,
                    oid_idioma_nativo: this.dato.oid_idioma_nativo,
                };

                await axios.put('api/PersonaInfoGenerals/Actualizar', payload);
                this.evaluarGeneral()              // ← vuelve a evaluar
                this.isDone[sectionKey] = true 
                this.isDone[sectionKey] = true;
                if (this.step < 7) this.step++;
                else this.onTerminar();
                this.$emit('toast', { color: 'success', text: 'Información general actualizada.' });
            } catch (e) {
                console.error(e);
                this.$emit('toast', { color: 'error', text: 'No fue posible guardar la información.' });
            } finally {
                this.loading = false;
            }
        },
        finalizarPerfil() {
            // Si quieres llamar a una API para marcar “perfil_completo”, hazlo aquí.
            this.dialogFinalizado = true;
        },
        irAVacantes() {
            this.dialogFinalizado = false;
            this.$router.push({ name: 'Inicio' }); // o la ruta que uses
        },
        onTerminar() {
            if (this.perfilCompleto) this.dialogFinalizado = true;
        },
        evaluarGeneral() {
            const d = this.dato
            this.isDone.general = !!(
            d.correo &&
            d.nombres &&
            d.apellidos &&
            d.oid_tipo_documento &&
            d.documento &&
            d.oid_genero &&
            d.fecha_nacimiento &&
            d.oid_pais_nacimiento &&
            d.oid_nacionalidad_origen &&
            d.oid_nacionalidad_actual &&
            d.oid_estado_civil &&
            d.direccion &&
            d.oid_pais &&
            d.oid_depto &&
            d.oid_ciudad &&
            d.telefono &&
            d.oid_idioma_nativo
            )
        },
        async mostrar(id) {
            try {
                const targetOid = (this.soloLectura && this.oidTemp) ? this.oidTemp : this.userOid;
                const { data } = await axios.get(`api/PersonaInfoGenerals/Mostrar/${targetOid}`);
                this.dato = {
                    ...this.dato,
                    ...data,
                    oid: data.oid,
                };

                // 👇 cargar “resumen” de secciones (idiomas, etc.)
                await this.cargarResumenPersona(this.dato.oid);
                this.isNew = false;
                this.formTitle = 'Detalle Persona';
                this.dialogdetail = true;
            } catch (error) {
                console.error(error);
            }
        },
        async cargarResumenPersona(personaId) {
            const [rIdiomas , rAcad, rLab, rOtros, rRefs] = await Promise.all([
                axios.get('api/PersonalIdiomas/Listar'),
                axios.get('api/PersonalAcademicas/Listar'),
                axios.get('api/PersonalLaborals/Listar'),
                axios.get('api/PersonalOtros/Listar'),
                axios.get('api/PersonalReferencias/Listar'),
            ]);

            this.resumen.idiomas = (rIdiomas.data || []).filter(x => x.oid_personal === personaId);
            this.resumen.academica  = (rAcad.data  || []).filter(x => x.oid_personal === personaId);
            this.resumen.laboral    = (rLab.data   || []).filter(x => x.oid_personal === personaId);
            this.resumen.otros      = (rOtros.data || []).filter(x => x.oid_personal === personaId);
            this.resumen.referencias= (rRefs.data  || []).filter(x => x.oid_personal === personaId);
        },
        async imprimir() {
            const el = this.$refs.hvPrint;
            if (!el) return;

            const w = window.open('', '', 'width=1024,height=768');

            const styles = Array.from(
            document.querySelectorAll('link[rel="stylesheet"], style')
            ).map(n => n.outerHTML).join('\n');

            w.document.write(`<!doctype html>
            <html>
                <head>
                    <meta charset="utf-8">
                    <title>HV - ${this.dato?.nombres || ''} ${this.dato?.apellidos || ''}</title>
                    ${styles}
                    <style>
                        @page { size: A4; margin: 16mm; }
                        html, body { background:#fff !important; padding:0; }
                        body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }

                        /* Mantener el ancho visual del diálogo */
                        .print-page { max-width: 1024px; margin: 0 auto; padding: 16px; }

                        /* Forzar el grid de Vuetify para que se vea como md (4 columnas) */
                        .row { display:flex; flex-wrap:wrap; margin-left:-12px; margin-right:-12px; }
                        .col { padding-left:12px; padding-right:12px; }
                        .col-12    { flex:0 0 100% !important; max-width:100% !important; }
                        .col-md-3  { flex:0 0 30% !important;  max-width:30% !important; }
                        .col-md-4  { flex:0 0 33.3333% !important; max-width:33.3333% !important; }
                        .col-md-6  { flex:0 0 50% !important;  max-width:50% !important; }
                        .col-md-8  { flex:0 0 66.6667% !important; max-width:66.6667% !important; }

                        /* Vuetify v2 genera clases col-12 col-md-3; asegúrate de que existan estas reglas */
                        [class*="col-"] { box-sizing: border-box; }

                        /* Tipografía/colores como en el diálogo */
                        strong { color:#001E43; }
                        .v-card, .v-sheet { box-shadow:none !important; }

                        /* Evitar overlays/impr. de diálogos */
                        .v-overlay, .v-dialog__content { display:none !important; }
                    </style>
                </head>
                <body>
                    ${el.outerHTML}
                </body>
            </html>`);

            w.document.close();

            // Esperar imágenes
            await Promise.all(Array.from(w.document.images).map(img =>
            img.complete ? Promise.resolve() : new Promise(res => { img.onload = img.onerror = res; })
            ));

            w.focus();
            w.print();
            w.close();
        },
        getPaisN, getDeptoN, getCiudadN, getNameById,
        // Carga de “resumen” (sin tablas) para el diálogo
        nivelLabel(oid) {
            const data = this.Ops2.find(c => c.oid === oid);
            return data ? data.name : 'Unknown';
        },
        getOpsN(oid) {
            const data = this.Ops.find(c => c.oid === oid);
            return data ? data.name : 'Unknown';
        },
        async mostrar2(id) {
            try {
                const targetOid = (this.soloLectura && this.oidTemp) ? this.oidTemp : this.userOid;
                const { data } = await axios.get(`api/PersonaInfoGenerals/Mostrar/${targetOid}`);
                this.dato = {
                    ...this.dato,
                    ...data,
                    oid: data.oid,
                };

                // 👇 cargar “resumen” de secciones (idiomas, etc.)
                await this.cargarResumenPersona(this.dato.oid);
            } catch (error) {
                console.error(error);
            }
        },
    },
    async mounted() {
        await this.cargarPerfil();
        await this.cargarCatalogos();

        
        await setDatos();
        this.LPais   = getPaises();
        this.LDepto  = getDeptos();
        this.LCiudad = getCiudades();

        // 👇 Si se usa como visor, cargar de una
        if (this.temp && this.oidTemp) {
            await this.mostrar2(this.oidTemp);
        }
    },
    watch: {
        isDone: {
            deep: true,
            immediate: true,
            handler() {
                this.$emit('completo', this.perfilCompleto);
            }
        },
        oidTemp: {
            immediate: true,
            handler(nv) {
                if (this.temp && nv) this.mostrar2(nv);
            }
        },
                // Si cambia el modo soloLectura (poco común, pero por si acaso), recarga
        soloLectura() {
            this.cargarPerfil();
        },
        perfilCompleto(nuevo, anterior) {
            if (nuevo && !anterior && !this.yaNotificadoPerfilCompleto) {
                this.dialogFinalizado = true;
                this.yaNotificadoPerfilCompleto = true;
            }
        },
    }
}
</script>
<style scoped>
    p {
        font-family: 'Heebo', sans-serif !important;
        font-size: 17px;        
        line-height: 1.6em;
    }
    h1 {
      font-family: 'Heebo', sans-serif !important;
        font-size: 2.5rem;
    }
    .section-title{
        color: rgb(0,30,67);
        font-size: 40px;
        margin: 12px 0 6px;
    }
    .section-title2{
        color: rgb(0,30,67);
        font-size: 25px;
        margin: 12px 0 6px;
        text-align: center;
    }
    .section-text{
        color: rgb(0,30,67);
        margin-top: 8px;
    }
    .section-divider{
        border-bottom: #29ABE2 solid 3px;
    }
</style>
